/**
 * Keccak256 constants
 *
 * @see https://voltaire.tevm.sh/crypto for crypto documentation
 * @since 0.0.0
 */

/**
 * Digest size in bytes (32 bytes = 256 bits)
 * @type {number}
 * @since 0.0.0
 */
export const DIGEST_SIZE = 32;

/**
 * Rate in bytes for Keccak256 (136 bytes = 1088 bits)
 * @type {number}
 * @since 0.0.0
 */
export const RATE = 136;

/**
 * State size (25 u64 words = 1600 bits)
 * @type {number}
 * @since 0.0.0
 */
export const STATE_SIZE = 25;
